<template>
  <q-dialog v-model="shown">
    <q-card style="width: 400px;">
      <q-card-section class="q-mx-xs">
        <div class="row items-center">
          <div class="text-h6">
            {{ title || 'Set Display Order' }}
          </div>
          <q-space />
          <q-btn
            v-if="orderOptions.length"
            icon="more_horiz"
            flat
            round
            dense
            :disable="loading"
          >
            <q-menu
              bordered
              overlay
            >
              <transition
                appear
                enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut"
              >
                <q-list
                  class="drawer-content"
                >
                  <q-item
                    v-for="orderOption in orderOptions"
                    :key="orderOption.name || orderOption"
                    v-ripple
                    clickable
                    :disable="loading"
                  >
                    <q-menu
                      bordered
                      overlay
                      anchor="top right"
                    >
                      <transition
                        appear
                        enter-active-class="animated fadeIn"
                        leave-active-class="animated fadeOut"
                      >
                        <q-list
                          class="drawer-content"
                        >
                          <q-item
                            v-ripple
                            clickable
                            :disable="loading"
                            @click="orderBy(orderOption.name || orderOption)"
                          >
                            <q-item-section>
                              Ascending
                            </q-item-section>
                          </q-item>
                          <q-item
                            v-ripple
                            clickable
                            :disable="loading"
                            @click="orderBy(orderOption.name || orderOption, true)"
                          >
                            <q-item-section>
                              Descending
                            </q-item-section>
                          </q-item>
                        </q-list>
                      </transition>
                    </q-menu>
                    <q-item-section
                      v-if="orderOption.icon"
                      avatar
                    >
                      <q-icon :name="orderOption.icon" />
                    </q-item-section>
                    <q-item-section>
                      <div class="row items-center justify-between">
                        <span class="col">{{ $_.startCase(orderOption.name || orderOption) }}</span>
                        <q-icon
                          class="col-auto"
                          name="chevron_right"
                        />
                      </div>
                    </q-item-section>
                  </q-item>
                </q-list>
              </transition>
            </q-menu>
          </q-btn>
          <q-btn
            v-close-popup
            icon="close"
            flat
            round
            dense
          />
        </div>
        <div
          v-if="description"
          class="text-caption"
        >
          {{ description }}
        </div>
      </q-card-section>
      <q-card-section>
        <set-display-order-form
          :list="list"
          :display-field="displayField"
          :loading="loading"
          @reorder="handleReorder"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import SetDisplayOrderForm from 'src/modules/admin/components/SetDisplayOrderForm'

export default {
  name: 'SetDisplayOrderDialog',
  components: {
    SetDisplayOrderForm
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      required: false,
      default: 'Set Display Order'
    },
    description: {
      type: String,
      required: false,
      default: null
    },
    list: {
      type: Array,
      required: true
    },
    displayField: {
      type: String,
      required: false,
      default: null
    },
    orderOptions: {
      type: Array,
      required: false,
      default: () => ([])
    },
    orderField: {
      type: String,
      required: false,
      default: 'displayOrder'
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value', 'reorder'],
  data () {
    return {
      shown: false,
      pagination: {
        itemsPerPage: 60,
        page: 0
      }
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    handleReorder (reorderedList) {
      this.$emit('reorder', { reorderedList, orderField: this.orderField })
    },
    orderBy (name, descending = false) {
      let reorderedList = _.sortBy(this.list, name)
      if (descending) {
        reorderedList = _.reverse(reorderedList)
      }
      this.$emit('reorder', { reorderedList, orderField: this.orderField })
      this.shown = false
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
